module.exports = __webpack_public_path__ + "img/360-giving-logo-white.754b0da8.svg";